import { isRecord, toArray, toId, toNumber } from '../../shared/utils/parse';
import type { StockPolicy, StockSnapshot } from '../models/catalog/stock.model';

/** Whitelist ограничивающих значений: незнакомая политика — fail-open, каталог гасить не за что. */
function mapPolicy(raw: unknown): StockPolicy {
  return raw === 'RESTRICTED_SHOW' || raw === 'RESTRICTED_HIDE' ? 'restricted' : 'allowed';
}

function mapStopped(raw: unknown): ReadonlySet<string> {
  const stopped = new Set<string>();
  for (const entry of toArray(raw)) {
    const id = toId(entry);
    if (id !== null) {
      stopped.add(id);
    }
  }
  return stopped;
}

function mapRemains(raw: unknown): ReadonlyMap<string, number> {
  const remains = new Map<string, number>();
  for (const entry of toArray(raw)) {
    if (!isRecord(entry)) {
      continue;
    }
    const id = toId(entry['positionId']);
    const quantity = toNumber(entry['quantity']);
    if (id === null || quantity === null) {
      continue;
    }
    // Минус — тот же ноль, дробь — вниз: количество в корзине целое, а сервер сверяет `qty <= остаток`.
    remains.set(id, Math.floor(Math.max(quantity, 0)));
  }
  return remains;
}

function mapByBranch(raw: unknown): ReadonlyMap<string, ReadonlyMap<string, number>> {
  const byBranch = new Map<string, ReadonlyMap<string, number>>();
  for (const entry of toArray(raw)) {
    if (!isRecord(entry)) {
      continue;
    }
    const branchId = toId(entry['branchId']);
    if (branchId === null) {
      continue;
    }
    byBranch.set(branchId, mapRemains(entry['remains']));
  }
  return byBranch;
}

/** Пустой `branches` штатен: при политике `ALLOWED` сервер количеств не шлёт вовсе. */
export function mapStock(raw: unknown): StockSnapshot {
  const source = isRecord(raw) ? raw : {};
  return {
    policy: mapPolicy(source['outOfStockPolicy']),
    stopped: mapStopped(source['stoppedFoodIds']),
    byBranch: mapByBranch(source['branches']),
  };
}
